// App
import React from 'react';

// Misc / styles
import { StyledLoadingBanner } from './styles';

export interface LoadingBannerProps {
  isMwebMapLoaded: boolean;
}

const LOADING_MESSAGE = 'Loading...';
const LoadingBanner = (props: LoadingBannerProps) => {
  return <StyledLoadingBanner isMwebMapLoaded={props.isMwebMapLoaded}>{LOADING_MESSAGE}</StyledLoadingBanner>;
};

export default LoadingBanner;
